module.exports = __webpack_public_path__ + "img/step_6.582e8a60.png";